import*as t from"./blackbird";import*as c from"./factbird";const o=typeof document<"u"?document.location.host:null,d=o?.includes("factbird.com")||o?.includes("localhost")||!1,i=d?"factbird":"blackbird";export{t as blackbird,i as brand,c as factbird};
//# sourceMappingURL=index.js.map
